import { Component, OnInit } from '@angular/core';
import { NbMenuService, NbThemeService } from '@nebular/theme';

import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '@services/account.service';
import { ROLES_ID_CONFIG } from '@config/roles.config';
import { ProfileService } from '@features/profile/profile.service';
import { NavigationService } from '@shared/services/navigation.service';
import { LoginService } from '@services/login.service';
import { environment } from '@environments/environment';

@Component({
  standalone: false,
  selector: 'ingsv-adm-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  roleKey: any;
  currentLang = 'no';
  rolesIdConfig = ROLES_ID_CONFIG;
  env = environment;

  languages = [
    {
      value: 'no',
      name: 'No',
    },
    {
      value: 'en',
      name: 'En',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: this.translateService.instant('LOGIN.PROFILE'), profile: true }, { title: this.translateService.instant('LOGIN.LOGOUT'), logout: true }];

  constructor(
    public loginService: LoginService,
    public accountService: AccountService,
    public profileService: ProfileService,
    public navigationService: NavigationService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    if (this.loginService.isLoggedIn) {
      this.roleKey = this.accountService.getRole().roleKey;
    }
    this.currentTheme = this.themeService.currentTheme;

    this.menuService.onItemClick().subscribe((event) => {
      this.onContecxtItemSelection(event.item);
    });
  }

  onContecxtItemSelection(item) {
    if (item.logout) {
      this.loginService.logout();
    }
  }

  changeLang(lang: string) {
    this.translateService.use(lang);
  }
}
